module.exports = __webpack_public_path__ + "static/media/bogo.5ea619bd.png";